/*
  Add feature keys here and document their build-time values in .env.template and
  .buildkite/pipeline.yml. Leave stage and production off until explicitly approved.
*/
interface Feature {
  featureName: string
  envVarName: string
}

type Features = {
  [Key in (typeof FEATURE_KEYS)[number]]?: Feature
}

const FEATURE_KEYS = [
  'ORG_REGISTRATION_AND_PAYMENT',
  'REFERRAL_CODE',
  'RTPM',
  'INTEGRATIONS',
  'SSO_SAML_REAUTHENTICATION',
  'SHARED_PATIENTS',
  'NEW_PLAN',
  'MULTIPLE_LOCATIONS',
  'DATA_EXPORTS',
  'MFA_SELF_SERVICE',
] as const

export const FEATURES: Features = FEATURE_KEYS.reduce(
  (features: Features, featureKey) => ({
    ...features,
    [featureKey]: {
      featureName: featureKey,
      envVarName: `REACT_APP_FEATURE_TOGGLE_${featureKey}_ENABLED`,
    },
  }),
  {}
)
